import type * as lazyIndex from './lazyIndex';
import { LazyModule, createLazyComponent, LazyAction, type LazyComponent } from 'owa-bundling';
import { GovernPriority } from 'owa-client-types/lib/GovernPriority';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "RebootModal" */ './lazyIndex'),
    { name: 'RebootModal', govern: GovernPriority.Idle }
);

export const RebootModal: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.RebootModal
);
export const lazySoftReboot: LazyAction<typeof lazyIndex.softReboot, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.softReboot);
export const lazyForceReboot: LazyAction<typeof lazyIndex.forceReboot, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.forceReboot);
